import { Heading, IHeadingProps } from 'native-base'
import React, { PropsWithChildren } from 'react'

import { AlignSelf } from '../props'

type ScreenHeadingProps = Omit<IHeadingProps, 'size'> & {
  children: React.ReactElement | string
  align?: AlignSelf
}

export const ScreenHeading: React.FC<PropsWithChildren<ScreenHeadingProps>> = ({
  children,
  align = 'flex-start',
  ...rest
}) => {
  return (
    <Heading
      color={'neutral.900'}
      accessibilityRole="header"
      accessibilityLevel={1}
      alignSelf={align}
      fontSize="xl"
      {...rest}
    >
      {children}
    </Heading>
  )
}
